import * as types from './types';
import { createTestErrorReducers } from '../../common/test-error/reducers';

const { initialState, reducer } = createTestErrorReducers(types);

export default reducer;
export { initialState };
